var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate } from "../../I18N";

import { Icon } from "../../UI";
import { addReference, saveTargetRangedReference } from "../actions/referencesActions";
import { cancelTargetDocument } from "../actions/documentActions";

export class TargetDocumentHeader extends Component {
  constructor(props) {
    super(props);
    this.save = this.save.bind(this);
  }

  save() {
    const { reference, connection } = this.props;
    const { targetRange, targetFile } = reference;
    return this.props.saveTargetRangedReference(connection.toJS(), targetRange, targetFile, (ref) => {
      this.props.addReference(ref, true);
    });
  }

  render() {
    const { targetDocument, reference } = this.props;
    const { targetRange } = reference;

    let className = 'btn btn-default hidden';

    if (targetDocument && targetRange) {
      className = 'btn btn-success';
    }

    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", { className: "relationship-steps is-fixed" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: this.props.cancelTargetDocument,
        className: "btn btn-default" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "arrow-left" }), /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Back")
      ), /*#__PURE__*/
      _jsx("h2", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Select target paragraph"), /*#__PURE__*/
      _jsx("small", {}, void 0, "3")
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "ContextMenu ContextMenu-center" }, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", onClick: this.save, className: className }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "save" }), /*#__PURE__*/
      _jsx("span", { className: "ContextMenu-tooltip" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Save")
      )
      )
      )
      ));

  }
}










function mapStateToProps({ documentViewer, connections }) {
  return {
    connection: connections.connection,
    reference: documentViewer.uiState.toJS().reference,
    targetDocument: documentViewer.targetDoc.get('_id')
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveTargetRangedReference,
      cancelTargetDocument,
      addReference
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TargetDocumentHeader);